export const DEFAULT_API_URL = 'https://alpha-api.docyrus.com';

export const DEFAULT_OAUTH_SCOPES = [
  'offline_access',
  'Read.All',
  'User.Read',
  'Users.Read.All',
  'DS.Read.All'
];

export const DEFAULT_CALLBACK_PATH = '/auth/callback';

export const DEFAULT_ALLOWED_HOST_PATTERN = /^https:\/\/[^/]+\.docyrus\.app$/;

/** localStorage key to persist the pre-redirect location */
export const REDIRECT_RETURN_KEY = 'docyrus_auth_return_url';

/** Buffer in seconds before token expiration to trigger refresh */
export const TOKEN_EXPIRY_BUFFER_SECONDS = 60;

/** Timeout for iframe token refresh requests (ms) */
export const IFRAME_TOKEN_REFRESH_TIMEOUT_MS = 10_000;

/** Timeout for app→host action acks (Send to Docy / Send to Chat) (ms) */
export const HOST_ACTION_TIMEOUT_MS = 15_000;

/** Timeout for host-proxied Microsoft Graph requests (ms) — Graph can be slow */
export const MSGRAPH_REQUEST_TIMEOUT_MS = 30_000;

/** Default cookie name for SSR token sync */
export const DEFAULT_SSR_COOKIE_KEY = 'docyrus-token';

/** URL query parameter name for SSO session tokens */
export const SSO_TOKEN_PARAM = 'sso_token';
